import { cn } from '@/lib/utils'

export type ConnectorSource = 'sharepoint' | 'google-drive' | 'onedrive' | 'dropbox'

interface SourceIconProps {
  source: ConnectorSource
  className?: string
  size?: number
}

function SharePoint({ size }: { size: number }) {
  return (
    <img
      src="/integrations/sharepoint.png"
      width={size}
      height={size}
      alt="SharePoint"
      className="object-contain"
    />
  )
}

function GoogleDrive({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Google Drive"
    >
      <path d="M8.1 3.5h7.8L22 14.5h-7.8L8.1 3.5z" fill="#FBBC04" />
      <path d="M8.1 3.5L2 14.5l3.9 6 6.1-11L8.1 3.5z" fill="#34A853" />
      <path d="M5.9 20.5h12.2l3.9-6h-12L5.9 20.5z" fill="#1A73E8" />
    </svg>
  )
}

function OneDrive({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="OneDrive"
    >
      <path
        d="M7.5 9.5a4.5 4.5 0 0 1 8.7-1.6 3.6 3.6 0 0 1 4.6 4 3.4 3.4 0 0 1-1.9 6.3H6.4a4 4 0 0 1-1-7.9c.4-.5 1.3-.8 2.1-.8z"
        fill="#0364B8"
      />
      <path
        d="M7.5 9.5a4.5 4.5 0 0 1 8.7-1.6 3.6 3.6 0 0 1 4.6 4l-9.6 6.3H6.4a4 4 0 0 1-1-7.9c.4-.5 1.3-.8 2.1-.8z"
        fill="#0078D4"
      />
    </svg>
  )
}

function Dropbox({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Dropbox"
    >
      <path d="M7 3l5 3.2-5 3.2-5-3.2L7 3z" fill="#0061FF" />
      <path d="M17 3l5 3.2-5 3.2-5-3.2L17 3z" fill="#0061FF" />
      <path d="M2 12.6l5-3.2 5 3.2-5 3.2-5-3.2z" fill="#0061FF" />
      <path d="M17 9.4l5 3.2-5 3.2-5-3.2 5-3.2z" fill="#0061FF" />
      <path d="M7 16.8l5-3.2 5 3.2L12 20l-5-3.2z" fill="#0061FF" />
    </svg>
  )
}

export function SourceIcon({ source, className, size = 16 }: SourceIconProps) {
  let icon: React.ReactNode
  switch (source) {
    case 'sharepoint':
      icon = <SharePoint size={size} />
      break
    case 'google-drive':
      icon = <GoogleDrive size={size} />
      break
    case 'onedrive':
      icon = <OneDrive size={size} />
      break
    case 'dropbox':
      icon = <Dropbox size={size} />
      break
  }

  return <span className={cn('inline-flex shrink-0 items-center justify-center', className)}>{icon}</span>
}
